@if (confirmationStyle === 'link') {
<a
  class="ob1-inline-suggestion-container ob1-inline-suggestion-{{style}}"
  [href]="confirmationPath || ''"
  [attr.data-e2e]="e2e"
  [ngClass]="{'ob1-inline-suggestion-container-iconless': !icon }"
  (click)="materialSuggestConfirm(); false"
>
  <ng-container [ngTemplateOutlet]="suggestBody"></ng-container>
</a>
} @else {
<div
  class="ob1-inline-suggestion-container ob1-inline-suggestion-{{style}}"
  [attr.data-e2e]="e2e"
  [ngClass]="{'ob1-inline-suggestion-container-iconless': !icon }"
>
  <ng-container [ngTemplateOutlet]="suggestBody"></ng-container>
</div>
}

<ng-template #suggestHeader>
  <div class="ob1-inline-suggestion">
    @if (icon) {
    <span class="ob1-inline-suggestion-icon {{icon}}" aria-hidden="true"></span>
    }
    <ng-content select=".ob1-inline-suggestion-title">
      <h3 class="ob1-inline-suggestion-title py-0" [attr.data-e2e]="e2e + '-title'">{{title}}</h3>
    </ng-content>
  </div>
</ng-template>

<ng-template #suggestBody>
  <ng-container [ngTemplateOutlet]="suggestHeader"></ng-container>
  <div class="ob1-inline-suggestion-content">
    <div [attr.data-e2e]="e2e + '-body'">
      <ng-content select="[body]">
        @if (displayedText()) {
        <p *ngFor="let item of displayedText()" class="ob1-inline-suggestion-text">{{item}}</p>
        }
      </ng-content>
    </div>
    <ng-container [ngTemplateOutlet]="suggestConfirm"></ng-container>
  </div>
</ng-template>

<ng-template #suggestConfirm>
  <!-- Suggestion confirmation -->
  @if (confirmationLabel && confirmationStyle !== 'link') {
  <!-- button confirmation style -->
  <a
    class="btn {{ btnStyle }}"
    [href]="confirmationPath"
    (click)="materialSuggestConfirm(); false"
    [attr.data-e2e]="e2e + '-confirmation'"
    [ecmDisabledAction]="isDisabledEclair"
  >
    {{confirmationLabel}} @if(isExternalUrl) {
    <span class="sr-only">( nouvelle fenêtre)</span>
    }
  </a>
  }
</ng-template>
